import { render, staticRenderFns } from "./SuccessDelete.vue?vue&type=template&id=e8c1e790&"
import script from "./SuccessDelete.vue?vue&type=script&lang=ts&"
export * from "./SuccessDelete.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessDelete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports